export class BluetoothDataError extends Error {
  constructor(message: string, public data: string) {
    super(message);
  }
}
